import { render } from "./Badage.vue?vue&type=template&id=700a9f3c"
import script from "./Badage.vue?vue&type=script&lang=js"
export * from "./Badage.vue?vue&type=script&lang=js"

import "./Badage.vue?vue&type=style&index=0&id=700a9f3c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__